import React from 'react';

export const Loading = () => {
  return (
    <div className="loading-container">
      <img src="/images/loader.gif"></img>
    </div>
  );
};
